import Vue from 'vue';
import Router, { Route } from 'vue-router';

Vue.use(Router);

// Containers
const DefaultContainer = () =>
  import(/* webpackChunkName: "DefaultContainer" */ '@/components/containers/default/DefaultContainer.vue');

// Views
const Registrations = () => import(/* webpackChunkName: "Registrations" */ '@/views/registrations/Registrations.vue');
const RegistrationDetails = () => import('@/views/registrationDetails/RegistrationDetails.vue');
const Tenants = () => import(/* webpackChunkName: "Tenants" */ '@/views/tenants/Tenants.vue');
const TenantDetails = () => import('@/views/tenantDetails/TenantDetails.vue');
const Users = () => import(/* webpackChunkName: "Users" */'@/views/users/Users.vue');
const UserDetails = () => import('@/views/userDetails/userDetails.vue');

const router = new Router({
  mode: 'history',
  linkActiveClass: 'open active',
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  routes: [
    {
      path: '/',
      name: 'Home',
      component: DefaultContainer,
      redirect: '/registrations',
      children: [
        {
          path: 'registrations',
          name: 'Registrations',
          component: Registrations,
        },
        {
          path: 'registrations/:registrationId',
          name: 'RegistrationsDetails',
          component: RegistrationDetails,
        },
        {
          path: 'tenants',
          name: 'Tenants',
          component: Tenants,
        },
        {
          path: 'tenants/:tenantId',
          name: 'TenantDetails',
          component: TenantDetails,
        },
        {
          path: 'tenants/:tenantId/users',
          name: 'Users',
          component: Users,
        },
        {
          path: 'tenants/:tenantId/users/:userId',
          name: 'UserDetails',
          component: UserDetails,
        },
      ],
    },
    {
      path: '*',
      redirect: '/',
    },
  ],
});

export function authenticationGuard(to: Route, from: Route, next: any) {
  const authService = router.app.$factory.createAuthService();

  if (!authService.isAuthenticated()) {
    authService.login();
  } else {
    return next();
  }
}

router.beforeEach(authenticationGuard);

export default router;
